export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/Ellipse.ffda1c3b.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};